import React from "react";
import { FaUser } from "react-icons/fa";
import dottedCurve from "../../assets/images/curved-line.svg";
import user from "../../assets/images/user.svg";
import codesandbox from "../../assets/images/codesandbox.svg";

const GangstaBetWorking = () => {
  return (
    <div className="gangstabet-working container  position-relative">
      <img className="dotted-line" src={dottedCurve} alt="Dotted Curve" />
      <div className="container">
        <div className="row title">
          <div>
            {/* <p className="pre-title">How to trade</p> */}
            <p className="about-title">
              Why GangstaBet?
            </p>
            <p className="about-subtitle">
              GangstaBets are a part of the Gangstaverse, a collection of 5,555 uniquely designed NFT art with on-chain storage of images & properties. Each GangstaBet has been thoroughly designed to match the apparels worn during the golden days of gangsters in the 1920s. The names of GangstaBets can be changed, stories can be added and the skills and ranks can be upgraded using the exclusive GangstaBet token ($GBET). Lastly, being a part of the Gangstaverse, GangstaBets will have more utility in other projects within Gangstaverse in the future. Being their primary asset, as the GangstaVerse keeps expanding, their utilities keep growing.</p>
          </div>
        </div>
        <div className="row d-flex title-description">
          <div className="col-md-3">
            {/* <div className="icons1">
              <img src={user} alt="User" className="icon" />
            </div> */}
            <div>
              <p className="task2">
                Transparent and fair distribution of NFTs
              </p>
              <p className="task-detail1"></p>
            </div>
          </div>

          <div className="col-md-3">
            {/* <div className="icons2 mx-auto">
              <img src={user} alt="User" className="icon" />
            </div> */}
            <div>
              <p className="task2">
                Full ownership of the artwork
                rights
              </p>
              {/* <p className="task-detail2">
                GangstaBet was inspired by gangster related television shows and movies, such as Peaky Blinders, The Untouchables and Capone. The 8-bit design was inspired by the legendary NFT project CryptoPunks.
              </p> */}
            </div>
          </div>

          <div className="col-md-3">
            {/* <div className="icons3">
              <img src={user} alt="User" className="icon" />
            </div> */}
            <div>
              <p className="task2">
                Changeable properties using $GBET
              </p>
              {/* <p className="task-detail3">
                Add some really cool descriptions related to the characters of
                gangstabet and let world know about what we have.
              </p> */}
            </div>
          </div>

          <div className="col-md-3">
            {/* <div className="icons3">
              <img src={user} alt="User" className="icon" />
            </div> */}
            <div>
              <p className="task2">
                8-bit Gangsters & Detectives
              </p>
              {/* <p className="task-detail3">
                Add some really cool descriptions related to the characters of
                gangstabet and let world know about what we have.
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GangstaBetWorking;
